import React, { CSSProperties } from 'react';
import Pagination from 'office-ui-fabric-react-pagination';
import styled from 'styled-components';
import { theme } from 'theme';

interface IProps {
  totalPage: number;
  handlePagination: (page: number) => void;
  currentPage: number;
  boundaryPagesRange?: number;
  siblingPagesRange?: number;
  styles?: CSSProperties;
}

const PaginationWrapper = styled.div`
  margin: 15px 0 0;

  button {
    background: transparent;
    color: #767676;

    &.ms-Button--primary {
      background: ${theme.colors.themePrimary};
      color: #fff;
    }
  }

  @media (max-width: 768px) {
    .pagination {
      display: flex;

      button.ms-Button--default {
        display: none;
      }

      button:first-child {
        display: block;
      }

      button:last-child {
        display: block;
      }
    }
  }
`;

const PaginationUI: React.FC<IProps> = ({
  totalPage,
  handlePagination,
  currentPage,
  styles,
  boundaryPagesRange,
  siblingPagesRange,
}) => {
  return totalPage > 1 ? (
    <PaginationWrapper style={styles}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        onChange={(page: number) => handlePagination(page)}
        boundaryPagesRange={
          boundaryPagesRange !== undefined ? boundaryPagesRange : 1
        }
        siblingPagesRange={
          siblingPagesRange !== undefined ? siblingPagesRange : 1
        }
        hideFirstAndLastPageLinks
      />
    </PaginationWrapper>
  ) : null;
};

export default PaginationUI;
